import React, { useEffect, useRef, useState } from "react";
import Drawer from "@mui/material/Drawer";
import camera from "../assets/svg/camera.svg";
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  InputBase,
  OutlinedInput,
  Paper,
  Typography,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import close from "../assets/svg/drawer_close.svg";
import * as Yup from "yup";
import { useFormik } from "formik";
import { db, storage } from "../firebaseConfig";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { toast } from "react-toastify";
import { packageHistory } from "./common/History/helper";
import { useDispatch, useSelector } from "react-redux";
import {
  getDetailsById,
  getLatestShelfPackage,
  getMasterData,
  getOnlySuites,
  updateMasterData,
  updateShelfPackageDetails,
} from "../helper/functions";
import { getNextPackageId } from "./common/helper";
import { setSelectedPackage } from "../store/commonSlice";
import CameraModal from "./CameraModal";
import { getDownloadURL, ref, uploadString } from "firebase/storage";
import { IoMdCloseCircleOutline } from "react-icons/io";

const initialValue = {
  brand: {
    brandName: "",
    brandLogo: "",
  },
  merchantIndicator: "",
  suiteNumber: "",
  isNoSuite: false,
  packageName: "",
  packagePhotos:[],
  packageTotalWeight: 0,
  shelfId: "",
  dimensionL: 0,
  dimensionW: 0,
  dimensionH: 0,
};

const validationSchema = Yup.object().shape({
  isNoSuite: Yup.boolean(),
  packageName: Yup.string().when("isNoSuite", {
    is: true,
    then: () => Yup.string().required("Package name is required"),
  }),
});

const EditPackageDrawer = ({
  pageName,
  open,
  onClose,
  collectionName,
  shipmentCollectionName,
  shipmentData,
}) => {
  const dispatch = useDispatch();
  const webcamRef = useRef(null);
  const [loadingPackage, setLoadingPackage] = useState(false);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openCameraModal, setOpenCameraModal] = useState(false);
  const user = useSelector((state) => state.auth.value);
  const { selectedRequest: userActiveData, selectedPackage: packageActiveData } = useSelector((state) => state.common);
  const editPackage = packageActiveData;

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        "& .MuiMenuItem-root": {
          "&:hover": {
            backgroundColor: "lightgray !important",
          },
        },
      },
    },
  };

  const checkCamera = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasVideoInput = devices.some(
        (device) => device.kind === "videoinput"
      );
      return hasVideoInput;
    } catch (error) {
      console.error("Error checking for camera:", error);
      return false;
    }
  };

  const handleOpen = async () => {
    const checkForCamera = await checkCamera();
    if (checkForCamera) {
      setOpenCameraModal(true);
    } else {
      toast.error("No camera found");
    }
  };
  const handleClose = () => setOpenCameraModal(false);

  const handleCapture = async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    const storageRef = ref(storage, `packages/${new Date().getTime()}.jpg`);
    try {
      setOpenCameraModal(false);
      setLoadingPackage(true);
      const snapshot = await uploadString(storageRef, imageSrc, "data_url");
      const downloadURL = await getDownloadURL(snapshot.ref);
      const updatedPhotos = [downloadURL, ...(editPackageFormik.values.packagePhotos || [])];
      editPackageFormik.setFieldValue("packagePhotos", updatedPhotos);
    } catch (error) {
      console.error("Error uploading image: ", error);
    } finally {
      setLoadingPackage(false);
    }
  };

  const handlePhotoDelete = (index) => {
    const updatedPhotos = editPackageFormik.values.packagePhotos.filter((_, i) => i !== index);
    editPackageFormik.setFieldValue("packagePhotos", updatedPhotos);
  };

  useEffect(() => {
    const q = query(collection(db, "brands"));
    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const brandsArray = [];
        querySnapshot.forEach((doc) => {
          brandsArray.push({ id: doc.id, ...doc.data() });
        });
        setBrands(brandsArray);
      },
      (error) => {
        console.error("Error fetching brand data: ", error);
      }
    );
    return () => unsubscribe();
  }, []);

  const [initialValues, setInitialValues] = useState(initialValue);
  useEffect(() => {
    if (editPackage && editPackage.id) {
      const initialVals = {
        ...editPackage,
        brand: {
          brandName: editPackage?.brand?.brandName || "",
          brandLogo: editPackage?.brand?.brandLogo || "",
        },
        packagePhotos: editPackage?.packagePhotos || editPackage?.packageImages || [],
        merchantIndicator: editPackage.merchantIndicator || "",
        packageTotalWeight: editPackage.packageTotalWeight || editPackage.totalWeight || 0,
        shelfId: editPackage.shelfId || "",
        dimensionL: editPackage.dimensionL || 0,
        dimensionW: editPackage.dimensionW || 0,
        dimensionH: editPackage.dimensionH || 0,
      };
      setInitialValues(initialVals);
    } else {
      setInitialValues(initialValue);
    }
  }, [editPackage]);

  const editPackageFormik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      console.log("Form values:", values);
      setLoading(true);
      let mapUserData;
      try {
        console.log(values, "values in formik submit");

        if (values.suiteNumber && pageName === "NoSuites") {
          const mySuite = await getOnlySuites([
            {
              key: "routePartnerMainAddressId",
              operator: "==",
              value: packageActiveData?.warehouseAddressId,
            },
            {
              key: "uniqueAddressCode",
              operator: "==",
              value: values.suiteNumber,
            },
          ]);
          if (mySuite?.length == 0) {
            toast.error("Please validate suite number");
            return;
          } else {
            const masterData = await getMasterData();
            const latestPack = await getLatestShelfPackage(mySuite[0]?.id);
            const date = new Date();
            const year = date.getFullYear().toString().slice(-2); // Get the last two digits of the year
            const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Get the month and pad with leading zero if needed
            console.log(values,"photos after adding");
            
            const updatedPackage = await updateShelfPackageDetails(
              packageActiveData.id,
              {
                brand: values?.brand,
                brandName: values?.brand?.brandName || "",
                merchantIndicator: values?.merchantIndicator || "",
                packageId: values.isNoSuite
                  ? ""
                  : latestPack?.packageId
                    ? getNextPackageId(latestPack?.packageId)
                    : "A",
                suiteNumber: values?.suiteNumber || "",
                mySuiteId: mySuite[0]?.id,
                isNoSuite: false,
                packageName: values?.packageName || "",
                packagePhotos:values.packagePhotos,
                packageImages:values.packagePhotos,
                packageTotalWeight: values?.packageTotalWeight || 0,
                shelfId: values?.shelfId || "",
                dimensionL: values?.dimensionL || 0,
                dimensionW: values?.dimensionW || 0,
                dimensionH: values?.dimensionH || 0,
              }
            );
            toast.success("Packaging updated successfully!");
            onClose();
          }
        } else {
          const docRef = doc(
            db,
            collectionName,
            editPackage?.id
          );
          console.log(docRef, "docRef >>>>");
          let updateData = {
            ...values,
          };

          if (
            collectionName === "shelfPackages" ||
            collectionName === "shelfShoppingPackages"
          ) {
            updateData.packageTotalWeight = values.packageTotalWeight;
            updateData.packageImages = values.packagePhotos;
            updateData.packagePhotos = values.packagePhotos; // Ensure both fields are updated
          } else {
            const { packageTotalWeight, ...restValues } = values;
            updateData = {
              ...restValues,
              totalWeight: values.packageTotalWeight,
            };
          }
          await updateDoc(docRef, updateData);
          // Force refresh the package data using direct getDoc for immediate update
          const packageRef = doc(db, collectionName, editPackage?.id);
          const packageSnap = await getDoc(packageRef);
          
          if (packageSnap.exists()) {
            const updatedPackage = { ...packageSnap.data(), id: packageSnap.id };
            // Ensure both packageImages and packagePhotos are set correctly
            if (values.packagePhotos && values.packagePhotos.length > 0) {
              updatedPackage.packageImages = values.packagePhotos;
              updatedPackage.packagePhotos = values.packagePhotos;
            }
            dispatch(setSelectedPackage(updatedPackage));
          }
          
          toast.success("Packaging updated successfully!");
          onClose();
          (collectionName === "shelfPackages" ||
            collectionName === "shelfShoppingPackages") &&
            packageHistory(editPackage, values, user?.name, collectionName);
        }
      } catch (error) {
        console.error("Error updating document: ", error);
      } finally {
        setLoading(false);
      }
    },
  });
  console.log(editPackageFormik.errors);

  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={open}
      onClose={onClose}
      BackdropProps={{ sx: { background: "rgba(0, 0, 0, 0.5)" } }}
    >
      <Box sx={{ width: "500px" }}>
        <Box
          sx={{
            borderBottom: "1px solid #E5E5E8",
            paddingLeft: "20px",
            paddingTop: "20px",
            paddingBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" component="h5">
            Edit Package Details
          </Typography>
          <Box
            sx={{ paddingRight: "20px", cursor: "pointer" }}
            onClick={onClose}
          >
            <img src={close} alt="close" />
          </Box>
        </Box>
        <Box sx={{ minHeight: "84vh", borderBottom: "1px solid #E5E5E8" }}>
          <Box>
            <CameraModal
              open={openCameraModal}
              handleClose={handleClose}
              webcamRef={webcamRef}
              handleCapture={handleCapture}
            />
            <Box mb={3} ml={3}>
              <label
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Package images
              </label>
              <Box
                display="flex"
                flexWrap="wrap"
                sx={{
                  gap: "16px",
                  background: "white",
                  width: "fit-content",
                  borderRadius: "4px",
                  mt: 1,
                }}
              >
                {editPackageFormik.values.packagePhotos?.filter(url => url!=="")?.map((photo, index) => (
                  <Box key={index} position="relative">
                    <img
                      src={photo}
                      alt={`Package ${index}`}
                      style={{
                        height: "auto",
                        width: "75px",
                      }}
                    />
                    <IconButton
                      size="small"
                      color="error"
                      sx={{ position: "absolute", top: 0, right: 0 }}
                      onClick={() => handlePhotoDelete(index)}
                    >
                      <IoMdCloseCircleOutline fontSize="small" />
                    </IconButton>
                  </Box>
                ))}
                {loadingPackage && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress size={20} />
                  </Box>
                )}
                {editPackageFormik.values.packagePhotos?.length < 4 &&
                  Array.from(
                    {
                      length:
                        4 - editPackageFormik.values.packagePhotos?.length || 0,
                    },
                    (_, index) => (
                      <Grid item key={index}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Box
                            onClick={handleOpen}
                            sx={{
                              backgroundColor: "#FAFAFA",
                              width: "66px",
                              height: "66px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            <img src={camera} alt="camera" />
                          </Box>
                        </Box>
                      </Grid>
                    )
                  )}
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "20px",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Merchant
            </Typography>
            <Box>
              {collectionName === "shelfConsolidatedPackages" ? (
                <span>{editPackage?.merchantCount}</span>
              ) : (
                <FormControl
                  sx={{
                    m: 1,
                    minWidth: 270,
                    minHeight: "35px",
                    marginLeft: "0px",
                  }}
                  size="small"
                >
                  <Select
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    value={editPackageFormik.values.brand.brandName}
                    name="brand.brandName"
                    onChange={(e) => {
                      const selectedBrand = brands.find(
                        (brand) => brand.brandName === e.target.value
                      );
                      editPackageFormik.setFieldValue(
                        "brand.brandName",
                        selectedBrand?.brandName || ""
                      );
                      editPackageFormik.setFieldValue(
                        "brand.brandLogo",
                        selectedBrand?.brandLogo || ""
                      );
                    }}
                    renderValue={(selected) => {
                      if (!selected) {
                        return <em>Select Merchant</em>;
                      }
                      const selectedBrand = brands.find(
                        (brand) => brand.brandName === selected
                      );
                      return (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={selectedBrand?.brandLogo}
                            alt="brandLogo"
                            width="20px"
                            style={{ marginRight: "10px" }}
                          />
                          {selectedBrand?.brandName}
                        </Box>
                      );
                    }}
                    MenuProps={MenuProps}
                  >
                    {brands.map((item, index) => (
                      <MenuItem
                        value={item.brandName}
                        key={index}
                        sx={{
                          "& .MuiMenuItem-root:hover": {
                            backgroundColor: "lightgray",
                          },
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={item.brandLogo}
                            alt="brandLogo"
                            width="20px"
                            style={{ marginRight: "10px" }}
                          />
                          {item.brandName}
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Merchant Indicator
            </Typography>
            <Box>
              {collectionName === "shelfConsolidatedPackages" ? (
                <span>{editPackage?.merchantIndicator || "-"}</span>
              ) : (
                <FormControl
                  sx={{
                    m: 1,
                    minWidth: 270,
                    minHeight: "35px",
                    marginLeft: "0px",
                  }}
                  size="small"
                >
                  <OutlinedInput
                    value={editPackageFormik.values.merchantIndicator}
                    name="merchantIndicator"
                    onChange={editPackageFormik.handleChange}
                  />
                </FormControl>
              )}
            </Box>
          </Box>
          {initialValues.isNoSuite && (
            <>
              <Box sx={{ paddingLeft: "20px" }}>
                <Typography variant="body1" fontWeight="bold">
                  Suite number
                </Typography>
                <Paper
                  component="form"
                  sx={{
                    p: "2px 4px",
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #E5E5E8",
                    width: 350,
                    height: 40,
                    marginTop: "10px",
                  }}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Suit Number... "
                    inputProps={{ "aria-label": "search" }}
                    size="small"
                    name="suiteNumber"
                    value={editPackageFormik.values.suiteNumber}
                    onChange={editPackageFormik.handleChange}
                    disabled={!!editPackageFormik.values.isNoSuite}
                  />
                </Paper>
                {editPackageFormik.errors.suiteNumber &&
                  editPackageFormik.touched.suiteNumber && (
                    <div style={{ color: "red", fontSize: "14px" }}>
                      {editPackageFormik.errors.suiteNumber}
                    </div>
                  )}
              </Box>
              <FormGroup
                sx={{
                  paddingLeft: "20px",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      name="isNoSuite"
                      checked={editPackageFormik.values.isNoSuite}
                      onChange={editPackageFormik.handleChange}
                      disabled={!!editPackageFormik.values.suiteNumber}
                    />
                  }
                  label="No Suite"
                />
              </FormGroup>
            </>
          )}
          {initialValues.isNoSuite && editPackageFormik.values.isNoSuite && (
            <Box
              sx={{
                paddingLeft: "20px",
              }}
            >
              <Typography variant="body1" fontWeight="bold">
                Name on package
              </Typography>
              <Paper
                component="form"
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #E5E5E8",
                  width: 350,
                  height: 40,
                  marginTop: "10px",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Name on package... "
                  inputProps={{ "aria-label": "search" }}
                  size="small"
                  name="packageName"
                  value={editPackageFormik.values.packageName}
                  onChange={editPackageFormik.handleChange}
                />
              </Paper>
              {editPackageFormik.errors.packageName &&
                editPackageFormik.touched.packageName && (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {editPackageFormik.errors.packageName}
                  </div>
                )}
            </Box>
          )}
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Weight (lb)
            </Typography>
            <Box>
              <FormControl
                sx={{
                  m: 1,
                  minWidth: 270,
                  minHeight: "35px",
                  marginLeft: "0px",
                }}
                size="small"
              >
                <OutlinedInput
                  type="number"
                  name="packageTotalWeight"
                  value={editPackageFormik.values.packageTotalWeight}
                  onChange={editPackageFormik.handleChange}
                />
              </FormControl>
            </Box>
          </Box>
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Shelf ID
            </Typography>
            <Box>
              <FormControl
                sx={{
                  m: 1,
                  minWidth: 270,
                  minHeight: "35px",
                  marginLeft: "0px",
                }}
                size="small"
              >
                <OutlinedInput
                  name="shelfId"
                  value={editPackageFormik.values.shelfId}
                  onChange={editPackageFormik.handleChange}
                />
              </FormControl>
            </Box>
          </Box>
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            <Box>
              <Typography variant="body1" fontWeight="bold">
                Dimensions (cm)
              </Typography>
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <FormLabel>L</FormLabel>
                <Box>
                  <FormControl
                    sx={{ m: 1, maxWidth: 50, minHeight: "35px" }}
                    size="small"
                  >
                    <OutlinedInput
                      type="number"
                      name="dimensionL"
                      value={editPackageFormik.values.dimensionL}
                      onChange={editPackageFormik.handleChange}
                    />
                  </FormControl>
                </Box>
                <FormLabel>W</FormLabel>
                <Box>
                  <FormControl
                    sx={{ m: 1, maxWidth: 50, minHeight: "35px" }}
                    size="small"
                  >
                    <OutlinedInput
                      type="number"
                      name="dimensionW"
                      value={editPackageFormik.values.dimensionW}
                      onChange={editPackageFormik.handleChange}
                    />
                  </FormControl>
                </Box>
                <FormLabel>H</FormLabel>
                <Box>
                  <FormControl
                    sx={{ m: 1, maxWidth: 50, minHeight: "35px" }}
                    size="small"
                  >
                    <OutlinedInput
                      type="number"
                      name="dimensionH"
                      value={editPackageFormik.values.dimensionH}
                      onChange={editPackageFormik.handleChange}
                    />
                  </FormControl>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Button
          type="submit"
          variant="contained"
          onClick={editPackageFormik.handleSubmit}
          sx={{
            minWidth: "189px",
            position: "absolute",
            bottom: 20,
            right: 20,
            borderRadius: "4px",
          }}
          disabled={loading}
        >
          Save
        </Button>
      </Box>
    </Drawer>
  );
};

export default EditPackageDrawer;
